import { TerminalDesignTokens } from '@primeuix/themes/aura/terminal';

export const terminalTokens: TerminalDesignTokens = {
  root: {
    background: '{form.field.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    color: '{form.field.color}',
    height: '18rem',
    padding: '{form.field.padding.y} {form.field.padding.x}',
  },
  prompt: {
    gap: '0.25rem',
  },
  commandResponse: {
    margin: '2px 0',
  },
};
